module.exports = __webpack_public_path__ + "img/crm_omnichat.0ca447d4.png";